import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

import { useEffect, useState } from "react";
import { tamanioGrafica } from "utils/generalFunctions";

function redondearNumero(numero) {
  if (numero >= 1000) {
    const factor = 1000;
    return Math.ceil(numero / factor) * factor;
  } else if (numero >= 100) {
    const factor = 100;
    return Math.ceil(numero / factor) * factor;
  } else if (numero >= 10) {
    const factor = 10;
    return Math.ceil(numero / factor) * factor;
  } else {
    return Math.ceil(numero);
  }
}

const GraficaPotencia = ({
  datos = [],
  tipo,
  seleccionado1,
  seleccionado2,
}) => {
  const [datos1, setDatos1] = useState([]);
  const [datos2, setDatos2] = useState([]);
  const [horas, setHoras] = useState([]);
  const [maximoGrafica, setMaximoGrafica] = useState(0);

  const [datosGrafica, setDatosGrafica] = useState([]);

  useEffect(() => {
    setDatosGrafica([...datos]);
  }, [datos]);

  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler
  );

  useEffect(() => {
    let datos1Local = [];
    let datos2Local = [];
    let horas = [];

    datosGrafica.forEach((datoGrafica) => {
      horas.push(datoGrafica.hora);
      datos1Local.push(parseInt(datoGrafica.dato1));
      datos2Local.push(parseInt(datoGrafica.dato2));
    });

    if (datos1Local.length > 0) {
      let max1 = 0;

      datos1Local.forEach((elemento) => {
        if (elemento > max1) max1 = elemento;
      });

      if (datos2.length > 0) {
        let max2 = 0;

        datos2Local.forEach((elemento) => {
          if (elemento > max2) max2 = elemento;
        });

        if (max1 > max2) {
          setMaximoGrafica(max1);
        } else {
          setMaximoGrafica(max2);
        }
      } else {
        setMaximoGrafica(max1);
      }
    }

    setHoras([...horas]);
    setDatos1([...datos1Local]);
    setDatos2([...datos2Local]);
  }, [datosGrafica]);

  var misoptions = {
    scales: {
      y: {
        min: 0,
        max: redondearNumero(maximoGrafica),
      },
      x: {
        ticks: { color: "rgb(255, 99, 132)" },
      },
    },
  };

  let midata = {
    labels: horas,
    datasets: [
      // Cada una de las líneas del gráfico

      {
        label: seleccionado1 ? tipo + seleccionado1 : tipo,
        data: datos1,
        tension: 0,
        borderColor: "rgb(75, 138, 169)",
        borderWidth: 1,
        backgroundColor: "rgb(75, 138, 169)",
        pointRadius: 0,
        pointBorderColor: "rgb(75, 138, 169)",
        pointBackgroundColor: "rgb(75, 138, 169)",
      },
      {
        label: seleccionado2 ? tipo + seleccionado2 : tipo,
        data: datos2,
        tension: 0,
        borderColor: "rgb(201, 49, 69)",
        borderWidth: 1,
        backgroundColor: "rgb(201, 49, 69)",
        pointRadius: 0,
        pointBorderColor: "rgb(201, 49, 69)",
        pointBackgroundColor: "rgb(201, 49, 69)",
      },
    ],
  };

  return (
    <div className="w-100 flex justify-center pl-md-5 pr-md-5">
      <Line
        height={tamanioGrafica()}
        className="w-100 pl-lg-5 pr-lg-5"
        data={midata}
        options={misoptions}
      />
    </div>
  );
};

export default GraficaPotencia;
